module.exports = __webpack_public_path__ + "img/Mardona-3.c251f563.webp";